// Conversion events on top of GA4 (gtag) + Clarity. Only sent after analytics consent. Never pass personal data here.
import { analyticsActive } from "./consent";
const LANG_RE = /^\/(en|fr|tr)(?=\/|$)/;
const PROD_HOSTS = ["velmiraliving.com", "www.velmiraliving.com"];
const langOf = () => (window.location.pathname.match(LANG_RE) || [])[1] || "en";
const pageOf = () => window.location.pathname.replace(LANG_RE, "") || "/";

// Internal traffic = preview/dev hosts or a browser that has used the admin panel. Tagged for GA4 "Define internal traffic".
export const isInternalTraffic = () => {
  try {
    return !PROD_HOSTS.includes(window.location.hostname) || window.localStorage.getItem("vl_internal") === "1";
  } catch {
    return !PROD_HOSTS.includes(window.location.hostname);
  }
};
export const markInternalTraffic = () => {
  try { window.localStorage.setItem("vl_internal", "1"); } catch { /* storage blocked */ }
  if (typeof window.clarity === "function") {
    try { window.clarity("set", "traffic_type", "internal"); } catch { /* clarity optional */ }
  }
};

export const track = (event, params = {}) => {
  if (typeof window === "undefined") return;
  if (window.location.pathname.startsWith("/admin")) return;
  if (!analyticsActive()) return;
  const payload = { language: langOf(), page: pageOf(), ...params };
  if (isInternalTraffic()) payload.traffic_type = "internal";
  if (typeof window.gtag === "function") window.gtag("event", event, payload);
  if (typeof window.clarity === "function") {
    try { window.clarity("event", event); } catch { /* clarity optional */ }
  }
};

// One GA4 recommended `generate_lead` per successful submission (mark it as a key event in GA4).
export const trackLead = (lead_type, cta_location, extra = {}) => {
  track("generate_lead", { lead_type, cta_location, ...extra });
};

// Global delegate: phone + WhatsApp links anywhere on the site (header, footer, contact, articles).
export const installClickTracking = () => {
  const handler = (e) => {
    const a = e.target?.closest?.("a[href]");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    const loc = a.dataset?.testid || "link";
    if (href.startsWith("tel:")) track("phone_click", { cta_location: loc });
    else if (href.includes("wa.me")) track("whatsapp_click", { cta_location: loc });
  };
  document.addEventListener("click", handler, { capture: true });
  return () => document.removeEventListener("click", handler, { capture: true });
};
